const OPDHistory = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/History/Menses");
const BirthControl = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/History/BirthControl");
const Obstetrics = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/History/Obstetrics");
const ComplaintsOPD = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Complaints/Complaints");
const PrescriptionOPD = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Prescription/Prescription");
const AdviceOPD = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Advice/Advice");
const findingsObstretics = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/Obstretics");
const findingsNewBorn = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/NewBorn");
const findingsBreasts = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/Breast");
const findingsPelvic = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/Pelvic");
const findingsPerimetry = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/Perimetry");
const findingsGeneral = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/General");
const findingsPreVarginam = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/PreVaginam");
const findingsJoints = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/Joints");
const findingsMuscles = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/Muscles");
const findingsBones = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/Bones");
const findingsPediatrician = () =>
    import ( /* webpackChunkName: "OPD" */ "@/components/OPDNew/OPD/Findings/Pediatrician");

export default [{
        path: "",
        name: "OPDNew.root",
        redirect: {
            name: "OPDNew.OPDLeftSidebar.OPDHistory"
        }
    },
    {
        path: "OPDHistory",
        component: OPDHistory,
        name: "OPDNew.OPDLeftSidebar.OPDHistory"
    },
    {
        path: "BirthControl",
        component: BirthControl,
        name: "OPDNew.OPDLeftSidebar.BirthControl"
    },
    {
        path: "Obstetrics",
        component: Obstetrics,
        name: "OPDNew.OPDLeftSidebar.Obstetrics"
    },
    {
        path: "ComplaintsOPD",
        component: ComplaintsOPD,
        name: "OPDNew.OPDLeftSidebar.ComplaintsOPD"
    },
    {
        path: "PrescriptionOPD",
        component: PrescriptionOPD,
        name: "OPDNew.OPDLeftSidebar.PrescriptionOPD"
    },
    {
        path: "AdviceOPD",
        component: AdviceOPD,
        name: "OPDNew.OPDLeftSidebar.AdviceOPD"
    },
    {
        path: "findingsObstretics",
        component: findingsObstretics,
        name: "OPDNew.OPDLeftSidebar.findingsObstretics"
    },
    {
        path: "findingsNewBorn",
        component: findingsNewBorn,
        name: "OPDNew.OPDLeftSidebar.findingsNewBorn"
    },
    {
        path: "findingsBreasts",
        component: findingsBreasts,
        name: "OPDNew.OPDLeftSidebar.findingsBreasts"
    },
    {
        path: "findingsPelvic",
        component: findingsPelvic,
        name: "OPDNew.OPDLeftSidebar.findingsPelvic"
    },
    {
        path: "findingsPerimetry",
        component: findingsPerimetry,
        name: "OPDNew.OPDLeftSidebar.findingsPerimetry"
    },
    {
        path: "findingsGeneral",
        component: findingsGeneral,
        name: "OPDNew.OPDLeftSidebar.findingsGeneral"
    },
    {
        path: "findingsPreVarginam",
        component: findingsPreVarginam,
        name: "OPDNew.OPDLeftSidebar.findingsPreVarginam"
    },
    {
        path: "findingsJoints",
        component: findingsJoints,
        name: "OPDNew.OPDLeftSidebar.findingsJoints"
    },
    {
        path: "findingsMuscles",
        component: findingsMuscles,
        name: "OPDNew.OPDLeftSidebar.findingsMuscles"
    },
    {
        path: "findingsBones",
        component: findingsBones,
        name: "OPDNew.OPDLeftSidebar.findingsBones"
    },

    {
        path: "findingsPediatrician",
        component: findingsPediatrician,
        name: "OPDNew.OPDLeftSidebar.findingsPediatrician"
    }
];